import React, { useState, useEffect, useRef, CSSProperties } from 'react';
import styles from './ReferralProgram.module.scss'
import { ROUTES } from '../../lib/constants';
import APIService from '../../lib/api.service';

import { Button } from '../../components/Button/Button';

import { PulseLoader } from 'react-spinners';

export const ReferralForm = (): React.JSX.Element => {
  // Form focus
  const topRef = useRef(null);
  const [triggerFocus, setTriggerFocus] = useState(false);

  // Form data
  const [formData, setFormData] = useState({
    customername: '',
    customeraddress: '',
    customerunit: '',
    customerphone: '',
    referralname: '',
    referraladdress: '',
    referralunit: '',
    referralphone: '',
  });

  // Errors/prompts
  const [showInitialPrompt, setShowInitialPrompt] = useState(true)
  const [showForm, setShowForm] = useState(true);
  const [showSuccessPrompt, setShowSuccessPrompt] = useState(false);
  const [showFailedPrompt, setShowFailedPrompt] = useState(false);

  // Loading spinner
  const [showLoader, setShowLoader] = useState(false);
  const [color, setColor] = useState("#FFA500");
  const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "orange",
  };


  useEffect(() => {
    if (triggerFocus) {
      topRef.current.focus();
    }

    setTriggerFocus(false);
  }, [triggerFocus]);


  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setShowSuccessPrompt(false);
    setShowFailedPrompt(false);
    setShowInitialPrompt(false);
    setShowForm(false);

    setTriggerFocus(true);
    setShowLoader(true);

    if (!formData.customerunit) {
      formData.customerunit = null;
    }

    if (!formData.referralunit) {
      formData.referralunit = null;
    }

    try {
      const submit = await APIService.postReferralInfo(JSON.stringify(formData));

      setShowLoader(false);
      if (submit.status === 201) {
        setShowSuccessPrompt(true);
      } else if (submit.status === 500) {
        setShowFailedPrompt(true);
        setShowForm(true);
      }

    } catch (error) {
      setShowLoader(false);
      setShowFailedPrompt(true);
      setShowForm(true);
    }
  }


  return (
    <form className={styles.form} onSubmit={onSubmit}>
      <div
        ref={topRef}
        tabIndex={-1} // Makes the div focusable
        style={{ outline: 'none' }}
      >
        <h2 className='headline__h3 color--daylight-blue'>
          Refer a Friend
        </h2>

        {showInitialPrompt &&
          <div>
            <p>
              <a href={ROUTES.login.path} target='_self'>Log in</a> to your account for your personalized referral code to share
            </p>

            <p>
              Or
            </p>

            <p>
              Provide your friend&apos;s information here:
            </p>
          </div>
        }

        {showSuccessPrompt &&
          <div>
            <p>
              Your referral has been successfully submitted! If you have any questions, please contact us at <a href="mailto:concierge@citysidefiber.com"> concierge@citysidefiber.com.</a>
            </p>
          </div>
        }

        {showFailedPrompt &&
          <div>
            <p>
              Hmm... it looks like we're having trouble submitting your referral. Try again in a couple minutes, and if that doesn't work, please contact us at <a href="mailto:concierge@citysidefiber.com"> concierge@citysidefiber.com.</a>
            </p>
          </div>
        }

        {showLoader &&
          <center>
            <PulseLoader
              color={color}
              loading={showLoader}
              cssOverride={override}
              size={25}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </center>
        }
      </div>

      {showForm &&
      <div>
      <div>
        <div>
          <label>Your Name</label>
          <input
            type='text'
            name='customername'
            value={formData.customername}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Your Phone Number</label>
          <input
            name='customerphone'
            type='tel'
            pattern='[0-9]{3}-?[0-9]{3}-?[0-9]{4}'
            placeholder='XXX-XXX-XXXX'
            value={formData.customerphone}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Your Home Address</label>
          <input
            type='text'
            name='customeraddress'
            value={formData.customeraddress}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Your Unit Number (if applicable)</label>
          <input
            type='text'
            name='customerunit'
            value={formData.customerunit}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Their Name</label>
          <input
            type='text'
            name='referralname'
            value={formData.referralname}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Their Phone Number</label>
          <input
            name='referralphone'
            type='tel'
            pattern='[0-9]{3}-?[0-9]{3}-?[0-9]{4}'
            placeholder='XXX-XXX-XXXX'
            value={formData.referralphone}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Their Home Address</label>
          <input
            type='text'
            name='referraladdress'
            value={formData.referraladdress}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Their Unit Number (if applicable)</label>
          <input
            type='text'
            name='referralunit'
            value={formData.referralunit}
            onChange={handleChange}
          />
        </div>
      </div>

      <Button
        type='submit'
        size='lg'
        fullWidth={true}
        className='bg-color--daylight-blue'
      >
        Submit
      </Button>
      </div>
    }
    </form>

  )
}